import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const EnterpriseCreation = lazy(() => import("@root/Enterprise/create"));
const EnterprisesDashboard = lazy(() => import("@root/Enterprise/dashboard"));
const EnterpriseDetails = lazy(() => import("@root/Enterprise/details"));
const ErrorPage = lazy(() => import("@root/error"));

export const enterprisesRoutes: RouteObject[] = [
  {
    path: "/v2/enterprises/create",
    element: <EnterpriseCreation />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/enterprises/dashboard",
    element: <EnterprisesDashboard />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/v2/enterprise/:id",
    element: <EnterpriseDetails />,
    errorElement: <ErrorPage />,
  },
];
